import { styled } from '@mui/material';

const PREFIX = 'Financial';

export const classes = {
  marginLg: `${PREFIX}-marginLg`,
};

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.marginLg}`]: {
    marginTop: theme.spacing(1),
  },
}));
